import { fontsConfig as r, inputRecipe as e, typographyRecipe as o } from "@huspy/briks-core";
import { defineSlotRecipe as i } from "@pandacss/dev";
import { anatomy as t } from "../../node_modules/@ark-ui/anatomy/dist/select/index.mjs";
const p = i({
  className: "select",
  slots: t.keys(),
  base: {
    root: {
      fontFamily: r.sansSerif.family,
      overflow: "hidden"
    },
    trigger: {
      ...e.base,
      _hover: e.hover,
      _focus: { ...e.focus, boxShadow: "unset!" }
    },
    content: {
      borderRadius: "2",
      padding: "1.5",
      border: "unset",
      boxShadow: "0px 0px 18px 0px rgba(0, 0, 0, 0.10)"
    },
    item: {
      borderRadius: "2",
      padding: "2.5",
      _hover: {
        background: "bg-primary_hover"
      }
    },
    itemText: {
      ...o.size["sans-serif"].lg,
      ...o.weight.medium
    }
  }
});
export {
  p as select
};
